import React from "react";

const UsersManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44.579"
      height="46.413"
      viewBox="0 0 44.579 46.413"
    >
      <g id="db61" transform="translate(-212.249 -205.514)">
        <path
          id="Path_1343"
          data-name="Path 1343"
          d="M274.831,223.193a8.839,8.839,0,1,0-8.839-8.839A8.848,8.848,0,0,0,274.831,223.193Z"
          transform="translate(-46.427 0)"
          fill={fill ? fill : "#fb9f34"}
        />
        <path
          id="Path_1344"
          data-name="Path 1344"
          d="M396.866,390.634a.644.644,0,0,0-.635-.533h-1.352a9.3,9.3,0,0,0-.947-2.282l.955-.955a.643.643,0,0,0,.071-.826,10.873,10.873,0,0,0-2.7-2.69.645.645,0,0,0-.825.075l-.947.953a9.251,9.251,0,0,0-2.28-.946v-1.352a.645.645,0,0,0-.533-.635,11.311,11.311,0,0,0-3.795,0,.645.645,0,0,0-.541.636v1.356a9.168,9.168,0,0,0-2.265.934l-.949-.948a.644.644,0,0,0-.826-.072,11.134,11.134,0,0,0-2.7,2.7.645.645,0,0,0,.072.827l.95.95a9.365,9.365,0,0,0-.94,2.279h-1.352a.645.645,0,0,0-.635.532,10.806,10.806,0,0,0-.16,1.894,11.905,11.905,0,0,0,.158,1.9.645.645,0,0,0,.636.541h1.356a9.179,9.179,0,0,0,.941,2.272l-.948.948a.645.645,0,0,0-.072.826,10.941,10.941,0,0,0,2.681,2.681.646.646,0,0,0,.826-.072l.948-.948a9.181,9.181,0,0,0,2.272.941v1.356a.645.645,0,0,0,.541.636,11.684,11.684,0,0,0,1.9.161,10.8,10.8,0,0,0,1.893-.16.645.645,0,0,0,.533-.635v-1.352a9.368,9.368,0,0,0,2.279-.941l.95.951a.642.642,0,0,0,.827.071,11.083,11.083,0,0,0,2.695-2.7.645.645,0,0,0-.071-.826l-.948-.949a9.151,9.151,0,0,0,.934-2.264h1.357a.645.645,0,0,0,.636-.541,11.888,11.888,0,0,0,.158-1.9,10.956,10.956,0,0,0-.161-1.893Zm-7.194,1.894a3.681,3.681,0,0,1-.274,1.424.7.7,0,0,0-.03.09c0,.01-.01.019-.013.03a3.966,3.966,0,0,1-2.024,2.034.672.672,0,0,0-.124.037,3.815,3.815,0,0,1-2.914-.022l-.053-.022a3.925,3.925,0,0,1-2.019-2l-.053-.133a3.767,3.767,0,0,1-.276-1.436,3.7,3.7,0,0,1,.274-1.424.518.518,0,0,0,.036-.1,3.931,3.931,0,0,1,2.036-2.043l.037-.017c.028-.008.055-.017.082-.028a3.87,3.87,0,0,1,2.861,0,.621.621,0,0,0,.067.023l.026.013a3.963,3.963,0,0,1,2.06,2.071.609.609,0,0,0,.025.072,3.753,3.753,0,0,1,.276,1.435Z"
          transform="translate(-140.198 -151.844)"
          fill={fill ? fill : "#fb9f34"}
        />
        <path
          id="Path_1345"
          data-name="Path 1345"
          d="M233.118,364.2a12.409,12.409,0,0,1,5.916-10.614.644.644,0,0,0,.088-1.03,16.155,16.155,0,0,0-26.873,12.089.644.644,0,0,0,.644.644h19.6a.644.644,0,0,0,.644-.644.625.625,0,0,0-.021-.165c0-.092,0-.185,0-.279Z"
          transform="translate(0 -123.509)"
          fill={fill ? fill : "#fb9f34"}
        />
      </g>
    </svg>
  );
};

export default UsersManagementIcon;
